import { createApi } from '@reduxjs/toolkit/query/react';
import { dynamicBaseQuery } from '../badRequestHandler';

export const lockers = createApi({
  reducerPath: 'lockers',
  baseQuery: dynamicBaseQuery,
  tagTypes: ['Lockers'],
  endpoints: (builder) => ({
    getAllLockers: builder.query({
      query: (params) => ({
        url: '/lockers/all',
        method: 'GET',
        params,
      }),
      providesTags: ['Lockers'],
    }),
    addLocker: builder.mutation({
      query: (body) => ({
        url: '/lockers',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Lockers'],
    }),
    addLockerInvoice: builder.mutation({
      query: (body) => ({
        url: '/locker-invoices',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Lockers'],
    }),
  }),
});

export const { useGetAllLockersQuery, useAddLockerMutation, useAddLockerInvoiceMutation } = lockers;
